import { render, staticRenderFns } from "./CalendarList.vue?vue&type=template&id=62246f28&scoped=true"
import script from "./CalendarList.vue?vue&type=script&lang=js"
export * from "./CalendarList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62246f28",
  null
  
)

export default component.exports